// hooks/useOBMutation.ts
import { useMutation } from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useMemo } from 'react';

interface Options {
  method?: 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  queryKeysToInvalidate?: string[];
  onSuccess?: () => void;
  data?: any;
  onError?: () => void;
  headers?: Record<string, any>;
}

export function useOBMutation<T = any, K = void>(
  url: string,
  options: Options,
) {
  const brandName = useOnlineBookingStore(state => state.brandName);
  const jwtToken = useOnlineBookingStore(state => state.jwtToken);
  const headers: Record<string, string> = useMemo(
    () => ({
      ...(options?.headers || {}),
      ...(jwtToken && { 'x-user-context': jwtToken }),
      ...(brandName && { 'x-brand-code': brandName }),
    }),
    [options?.headers, jwtToken, brandName],
  );

  const newOptions = useMemo(
    () => ({
      ...options,
      headers,
    }),
    [options, headers],
  );

  return useMutation<T, K>(url, newOptions);
}
